import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { DEFAULT_USER, IS_DEMO } from 'config.js';
import { messages } from 'lang/messages/messages';
import { actions } from 'react-table';

const initialState = {
    articlesList: {},
    Articlenotification: {},
    statusHistory: {},
    TotalArticleList:{}
};

const ArticlesSlice = createSlice({
    name: 'articleslist',
    initialState,
    reducers: {
        setArticlesList(state, action) {
            state.articlesList = action.payload;
        },
        setToast(state, action) {
            state.Articlenotification = action.payload;
        },
        setStatusHistory(state, action) {
            state.statusHistory = action.payload;
        },
        setTotalArticleList(state,action)
        {
            state.TotalArticleList=action.payload;
        }
    },
});



export const ArticlesListApi = (tokendata, page, limit, search, journalid,apitype) => async (dispatch) => {

    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/submitManuScriptList?page=${page}&limit=${limit}&search=${search}&type=${apitype}&journal_uuid=${journalid}`,
        {
            headers: {
                "authorization": ` Bearer ${tokendata}`
            }
        }
    )
        .then((res) => {
            console.log(res, "fsdfff")
            dispatch(setArticlesList(res?.data?.data))
            // dispatch(setToast({
            //     status: true, message: res?.data?.message
            // }))


        })
        .catch((err) => {
            console.log(err?.response, "wddss");


        })

}



export const StatusHistoryListApi = (tokendata, uuid) => async (dispatch) => {

    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/manuscript/status/history/${uuid}`,
        {
            headers: {
                "authorization": ` Bearer ${tokendata}`
            }
        }
    )
        .then((res) => {
            console.log(res, "fsdfff")
            dispatch(setStatusHistory(res?.data?.data))
            // dispatch(setToast({
            //     status: true, message: res?.data?.message
            // }))


        })
        .catch((err) => {
            console.log(err?.response, "wddss");


        })

}

export const FinalDipositionApi = (tokendata, uuid, payload) => async (dispatch) => {

    const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/ats/manuscript/finaldisposition/${uuid}`, payload,
        {
            headers: {
                "Authorization": `Bearer ${tokendata}`,
            },
        }
    ).then((res) => {
        console.log(res, "fsdfffdfvfbg")

        dispatch(
            setToast({
                status: true,
                message: res?.data?.message,
            }))


    })
        .catch((err) => {
            console.log(err?.response, "wddssgfbhj");
            dispatch(
                setToast({
                    status: false,
                    message: err?.response?.data?.message,
                })
            )
        })

}


export const TotalArticlesListApi = (tokendata, page, limit, search, journalid) => async (dispatch) => {

    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/submitManuScriptList?page=${page}&limit=${limit}&search=${search}&type=`,
        {
            headers: {
                "authorization": ` Bearer ${tokendata}`
            }
        }
    )
        .then((res) => {
            console.log(res, "fsdfff")
            dispatch(setTotalArticleList(res?.data?.data))
            // dispatch(setToast({
            //     status: true, message: res?.data?.message
            // }))


        })
        .catch((err) => {
            console.log(err?.response, "wddss");


        })

}

// export const AcceptedArticleEditSubmissionApi = (tokendata, uuid, payload) => async (dispatch) => {

//     const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/ats/publisher/update/manuscript/${uuid}`, payload,
//         {
//             headers: {
//                 "Authorization": `Bearer ${tokendata}`,
//             },
//         }
//     ).then((res) => {
//         console.log(res, "fsdfffdfvfbg")

//         dispatch(
//             setToast({
//                 status: true,
//                 message: res?.data?.message,
//             }))


//     })
//         .catch((err) => {
//             console.log(err?.response, "wddssgfbhj");
//             dispatch(
//                 setToast({
//                     status: false,
//                     message: err?.response?.data?.message,
//                 })
//             )
//         })

// }




export const { setArticlesList, setToast, setStatusHistory ,setTotalArticleList} = ArticlesSlice.actions;
const ArticlesReducer = ArticlesSlice.reducer;

export default ArticlesReducer;
